export const SHORT_DATE_FORMAT = 'DD MMM';
export const DATE_WITH_TIME_FORMAT = 'DD MMM YYYY (HH:mmA)';
export const PERIOD_DATE_FORMAT = 'MMM YYYY';
export const FULL_PERIOD_DATE_FORMAT = 'MMMM YYYY';
export const API_DATE_FORMAT = 'YYYY-MM-DD';
export const DATE_PICKER_FORMAT = 'MM/DD/YYYY'
